import type { FieldValidator } from 'final-form';
import { composeValidators } from './composeValidators';

const transformValidateProp = <FieldValue>(
  validate?: FieldValidator<FieldValue>[] | FieldValidator<FieldValue> | null
): FieldValidator<FieldValue> | undefined => {
  let composedValidators;
  if (validate) {
    if (typeof validate === 'function') {
      composedValidators = validate;
    } else {
      composedValidators = composeValidators<FieldValue>(...validate);
    }
  }
  return composedValidators as FieldValidator<FieldValue>;
};

export default transformValidateProp;
